<!--
 * @Author: Gaho
 * @Date: 2024-01-29 10:04:52
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-11 15:39:09
 * @Description: 
-->
<template>
    <div
        class="mb-4 grid grid-cols-10 sm:grid-cols-2 mx-auto gap-2 w-full content-center"
    >
        <div
            class="flex flex-col relative m-auto gap-2 col-span-3 sm:col-span-7 items-center justify-center"
        >
            <!-- 旋转角度 :angle="20" -->
            <q-circular-progress
                :value="profile.userStatistic?.levelProgress"
                size="120px"
                color="[#1BB83D]"
                class=""
                :thickness="0.08"
            />
            <div class="user-avatar-container w-[100px] h-[100px]">
                <UserAvatar
                    size="100%"
                    :src="profile.userStatistic?.avatar"
                />
            </div>
            <span
                class="bg-[#ed1d49] translate-y-[-100%] m-auto text-white px-2 text-center text-xs font-semibold rounded-xl left-[50%] top-[75%]"
            >
                {{ profile.userStatistic?.level || 1 }}
                {{ $t('menuAndBtn.rank') }}
            </span>
        </div>

        <div class="flex flex-col flex-1 col-span-7 sm:sm:row-span-2 items-center">
            <div class="flex flex-col w-full space-y-1 mb-2">
                <span class="text-xs text-textFade font-semibold sm:text-center">
                    <!-- {{ history.timestamp }} -->
                    {{ currentDaysComputed }}
                </span>
                <div class="font-bold text-3xl sm:text-center flex items-center">
                    <p class="text-[18px]">
                        {{ profile.userStatistic?.name }}
                        <!-- ↓ 按测试人员提议，不显示 id  -->
                        <!-- ({{ profile.userStatistic?._id }}) -->
                    </p>
                    <!-- vip -->
                    <p class="text-[24px] vip-icon" v-if="profile.userStatistic?.isVip">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.58 9.96a1.06 1.06 0 1 0-1.11-.01.49.49 0 0 0-.01.13c.06 1.32-.95 1.69-1.51 1.7-1.13 0-1.53-.76-1.62-1.41a.8.8 0 0 0-.54-1.38.8.8 0 0 0-.16 1.57l.95 5.12c.04.19.2.33.4.33h6.06a.4.4 0 0 0 .39-.33l.94-5.12a.8.8 0 1 0-.7-.18c-.09.64-.48 1.4-1.6 1.4-.55-.01-1.55-.38-1.49-1.7a.5.5 0 0 0 0-.12Z"></path>
                        </svg>
                        VIP
                    </p>
                </div>
            </div>
            <!-- <CasinoHistoryModalUserProfilePreviewDropdown :profile="profile" /> -->
        </div>
    </div>
</template>

<script lang="ts" >
export default defineComponent({ name: 'UserProfilePreview' });
</script>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import type { UserProfileCurrenciesResponseState } from '~/socket/profile/dto';
import moment from 'moment';
import 'quasar/src/components/circular-progress/QCircularProgress.sass'; 

const props = defineProps({
    profile: {
        type: Object as PropType<UserProfileCurrenciesResponseState>,
        reqyired: true,
    },
});
const currentDaysComputed = computed(() => {
    let result = '';

    const userStatistic = props?.profile?.userStatistic;
    if (!userStatistic || !userStatistic.regDate) return result;
    const originalDate = moment(userStatistic.regDate);
    const currentDate = moment();

    const duration = moment.duration(currentDate.diff(originalDate));

    const years = duration.years();
    const months = duration.months();
    const days = duration.days();

    if (years > 0) {
        result += `${years} ${t.Years} `;
    }
    if (months > 0) {
        result += `${months} ${t.Months} `;
    } else {
        result += `${days} ${t.Days} `;
    }
    return result;
});


const t = useTranslation();
</script>

<style lang="scss" scoped>
.user-avatar-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -62%);
    z-index: 1;
    // @media (min-width: 280px) and (max-width: 574px) {
    //     transform: translate(-50%, -50%);
    // }
}

.vip-icon {
    align-items: center;
    background: linear-gradient(255.53deg,#ffb636 -.85%,#ff5c00 91.53%);
    border-radius: 16px;
    display: flex;
    font-size: 11px;
    font-weight: 700;
    height: 24px;
    line-height: 16px;
    margin-bottom: 0;
    margin-left: 8px;
    width: 53px;
    svg {
        font-size: 24px;
        height: 24px;
        width: 24px;
        fill: #fff;
    }
}
</style>